import React from 'react';
import { Outlet } from 'react-router-dom';
import GreenBg from './assets/greenbg.png';
import NotificationSystem from './components/NotificationSystem';
import Header from './UI/Header';
import Footer from './UI/Footer/Footer';
import './Layout.css';

const Layout = () => {


  return (
    <div
      className='layout-outer'
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#010C12',
        position: 'relative',
      }}
    >
      <Header />
      <img
        src={GreenBg}
        alt="Green Background"
        style={{
          position: 'absolute',
          top: '70%',
          left: '60%',
          transform: 'translate(-50%, -50%)',
          zIndex: 0,
          width: 'auto',
          height: '80vh',
          pointerEvents: 'none',
          opacity: 0.5,
        }}
      />
      <div style={{ display: 'flex', flex: 1, position: 'relative', zIndex: 1, minHeight: 0 }}>
        {/* <Sidebar /> */}
        <div className="content-wrapper" style={{ flex: 1, position: 'relative', zIndex: 1, minWidth: 0 }}>
          <NotificationSystem />
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
